export const HEADER_COLOR = '#D3D3D3';
export const PAGE_BORDER_WIDTH = 2;
export const FULL_WIDTH = 355 - PAGE_BORDER_WIDTH * 2;
export const FULL_HEIGHT = 216;
export const SECTION_GAP_WIDTH = 2;
export const LINE_Y_OFFSET = 0.5;
export const HEADER_HEIGHT = 24;
export const HEADER_WIDTH = FULL_WIDTH;
export const HEADER_LEFT = PAGE_BORDER_WIDTH;
export const HEADER_TOP = PAGE_BORDER_WIDTH;
export const ROW_SECTION_HEADER_HEIGHT = 4;
export const THIN_LINE = 0.25;
export const THICK_LINE = 0.5;

export const HEADER_1_SIZE = 9;
export const HEADER_2_SIZE = 7;
export const LOGO_LEFT = 2;
export const LOGO_TOP = PAGE_BORDER_WIDTH;
export const LOGO_WIDTH = 50;
export const LOGO_HEIGHT = 23;

export const OPERATOR_CONTRACTOR_TOP = PAGE_BORDER_WIDTH + 2;
export const OPERATOR_CONTRACTOR_LEFT = PAGE_BORDER_WIDTH + LOGO_WIDTH + 10;
export const OPERATOR_CONTRACTOR_WIDTH = 230;
export const OPERTAOR_CONTRACTOR_HEIGHT = 20;

export const DEPTH_TOP = PAGE_BORDER_WIDTH + 2;
export const DEPTH_LEFT = OPERATOR_CONTRACTOR_LEFT + OPERATOR_CONTRACTOR_WIDTH;
export const DEPTH_WIDTH = FULL_WIDTH - DEPTH_LEFT - PAGE_BORDER_WIDTH;
export const DEPTH_HEIGHT = OPERTAOR_CONTRACTOR_HEIGHT;

export const EXTERNAL_HEIGHT = 35;

export const DATA_TOP = HEADER_TOP + HEADER_HEIGHT + ROW_SECTION_HEADER_HEIGHT;
export const DATA_LEFT = PAGE_BORDER_WIDTH;
export const DATA_WIDTH = FULL_WIDTH;
export const DATA_HEIGHT = FULL_HEIGHT - PAGE_BORDER_WIDTH - DATA_TOP - ROW_SECTION_HEADER_HEIGHT - EXTERNAL_HEIGHT;

export const DATA_ROWS = 17;
export const DATA_COLUMNS_TRACKING = 6;
export const DATA_COLUMNS_NON = 3;

export const EXTERNAL_TOP = DATA_TOP + DATA_HEIGHT + ROW_SECTION_HEADER_HEIGHT;
export const EXTERNAL_LEFT = PAGE_BORDER_WIDTH;
export const EXTERNAL_WIDTH = FULL_WIDTH;
export const EXTERNAL_TOTAL_ROWS = 4;

export const EXTERNAL_TABLE_ROW_HEIGHT = 5;
export const EXTERNAL_TABLE_COLUMNS = 12;
export const MAX_STORAGE_ROWS = 35;


// WEBPACK FOOTER //
// ./src/Services/Pdf/VolumeAccountingSnapshotReport/SpecMilsVolumeSnapshot.ts